import React, { useState } from 'react';
import { Button, Card, Dropdown, Form, Modal } from 'react-bootstrap';
import CardDropdown from 'components/common/CardDropdown';
import { Link } from 'react-router-dom';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import CustomersTableHeader from './CustomersTableHeader';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import paths from 'routes/paths';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import SubtleBadge from 'components/common/SubtleBadge';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import PropTypes from 'prop-types';
import moment from 'moment';
import FalconCloseButton from 'components/common/FalconCloseButton';
import { sendCustomEmail } from 'nursd-dashboard/api/webNotification';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
// import IconItem from 'components/common/icon/IconItem';

const Shortened = address => {
  // Convert address to string
  const addressStr = address;

  // Check if addressStr is at least 7 characters long (for example)
  // You can adjust this condition based on your specific needs
  if (addressStr.length >= 7) {
    // Extract the first three characters
    const first = addressStr.substring(0, 15);

    // Extract the last three characters
    const last = addressStr.substring(addressStr.length - 10);

    // Create the shortened format
    const shortenedFormat = `${first}....${last}`;

    // Render the shortened format
    return shortenedFormat;
  } else {
    // If addressStr is shorter than 7 characters, return the original address
    return addressStr;
  }
};

const format = value => {
  const inputPhoneNumber = value.replace(/\D/g, '');
  const limitedPhoneNumber = inputPhoneNumber.slice(0, 10);
  const formattedPhoneNumber =
    limitedPhoneNumber.length === 10
      ? limitedPhoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
      : limitedPhoneNumber;
  return formattedPhoneNumber;
};

const Customers = ({
  updateCustomer,
  // deleteRecord,
  customers,
  downloadData,
  // setCustomers,
  getCustomer,
  setShow,
  setData
}) => {
  const handleShow = e => {
    setData(e?.original);
    setShow(true);
  };

  const { authToken } = useAuth();
  const [showModel, setShowModel] = useState(false);
  const [obj, setObj] = useState(undefined);
  const [content, setContent] = useState('');

  const handleClose = () => {
    setShowModel(false);
    setObj(undefined);
    setContent('');
  };

  const handleChange = ({ target }) => {
    setContent(target.value);
  };

  // const handleShowModel = e => {
  //   setShowModel(true);
  //   setObj(e);
  // };

  const sendEmail = async () => {
    // console.log(obj);
    // await postFacilityNotification(
    //   authToken,
    //   obj?.id,
    //   '',
    //   'Email Alert',
    //   'Check your email.',
    //   'NotificationScreen',
    //   {},
    //   false,
    //   false,
    //   'green',
    //   ''
    // );
    sendCustomEmail(authToken, {
      email: obj?.email,
      name: obj?.name,
      subject: 'Email Alert',
      content: '',
      body: content
    });
    handleClose();
  };

  const columns = [
    {
      accessorKey: 'name',
      header: 'Name',
      meta: {
        headerProps: { className: 'pe-1 text-900' },
        cellProps: {
          className: 'py-2'
        }
      },
      cell: ({ row: { original } }) => {
        const { id, name, avatar } = original;
        return (
          <Link to={paths.customer_profile(id)}>
            <Flex alignItems="center">
              {avatar.img ? (
                <Avatar src={avatar.img} size="xl" className="me-2" />
              ) : (
                <Avatar size="xl" name={avatar.name} className="me-2" />
              )}
              <div className="flex-1">
                <h5 className="mb-0 fs-10">{name}</h5>
              </div>
            </Flex>
          </Link>
        );
      }
    },
    {
      accessorKey: 'mrn',
      header: 'MRN',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { mrn } = original;
        return <h5 className="mb-0 fs-10">{mrn}</h5>;
      }
    },
    {
      accessorKey: 'email',
      header: 'Email',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { email } = original;
        return <a href={`mailto:${email}`}>{email}</a>;
      }
    },
    {
      accessorKey: 'password',
      header: 'Password',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { password } = original;
        return <h5 className="mb-0 fs-10">{password}</h5>;
      }
    },
    {
      accessorKey: 'phone',
      header: 'Phone',
      meta: {
        headerProps: { className: 'text-900' }
      },
      cell: ({ row: { original } }) => {
        const { phone } = original;
        return <a href={`tel:${phone}`}>{format(phone)}</a>;
      }
    },
    {
      accessorKey: 'address',
      header: 'Address',
      meta: {
        headerProps: {
          style: { minWidth: '200px' },
          className: 'ps-5 text-900'
        },
        cellProps: { className: 'ps-5' }
      },
      cell: ({ row: { original } }) => {
        const { address } = original;
        return <h5 className="mb-0 fs-10">{Shortened(address)}</h5>;
      }
    },
    {
      accessorKey: 'status',
      header: 'Status',
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        const { status } = original;
        return (
          <SubtleBadge pill bg={status ? 'success' : 'danger'}>
            {status ? 'Active' : 'Deactived'}
          </SubtleBadge>
        );
      }
    },
    {
      accessorKey: 'joined',
      header: 'Joined',
      meta: {
        headerProps: { className: 'text-900' },
        cellProps: { className: '' }
      },
      cell: ({ row: { original } }) => {
        const { joined } = original;
        return (
          <h5 className="mb-0 fs-10">
            {moment(joined).format('MMMM DD YYYY hh:mm a')}
          </h5>
        );
      }
    },
    {
      accessorKey: 'none',
      header: '',
      enableSorting: false,
      meta: {
        cellProps: {
          className: 'text-end'
        }
      },
      cell: ({ row: { original } }) => {
        const { status } = original;
        return (
          <Flex justifyContent={'end'}>
            {/* <IconItem
              tag="button"
              icon={'envelope-open'}
              size="sm"
              className="btn rounded-3"
              onClick={() => {
                handleShowModel(original);
              }}
            /> */}
            <CardDropdown>
              <div className="py-2">
                <Dropdown.Item onClick={() => handleShow(original)}>
                  Edit
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() =>
                    updateCustomer(original?.original?.id, !status)
                  }
                >
                  {status ? 'Deactivate' : 'Activate'}
                </Dropdown.Item>
                {/* <Dropdown.Item onClick={() => deleteRecord(original?.original)}>
                  Delete
                </Dropdown.Item> */}
              </div>
            </CardDropdown>
          </Flex>
        );
      }
    }
  ];

  const table = useAdvanceTable({
    data: customers,
    columns,
    // selection: true,
    sortable: true,
    pagination: true,
    perPage: 10
  });

  function convertToCSV(jsonData) {
    const separator = ',';
    const keys = Object.keys(jsonData[0]);
    const csvContent = [
      keys.join(separator),
      ...jsonData.map(item => {
        // Extract the 'fullAddress' property
        const { fullAddress, ...rest } = item;

        // Join the values of the other properties with the 'FullAddress' value
        const values = keys.map(key =>
          key === 'fullAddress' ? `"${fullAddress}"` : rest[key]
        );

        return values.join(separator);
      })
    ].join('\n');

    return csvContent;
  }

  const downloadCSVFile = data => {
    let current = moment().format('MM-DD-YYYY');
    // Create a Blob object for the CSV data
    const blob = new Blob([data], { type: 'text/csv' });

    // Create a temporary URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.download = `CustomerDetails-${current}.csv`;

    // Trigger the download
    link.click();

    // Clean up the temporary URL
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <AdvanceTableProvider {...table}>
        <Card className="mb-3">
          <Card.Header>
            <CustomersTableHeader
              customers={customers}
              // setCustomers={setCustomers}
              getCustomer={getCustomer}
              handleDownload={() => downloadCSVFile(convertToCSV(downloadData))}
            />
          </Card.Header>
          <>
            <Card.Body className="p-0">
              <AdvanceTable
                headerClassName="bg-200 text-nowrap align-middle"
                rowClassName="align-middle white-space-nowrap"
                tableProps={{
                  size: 'sm',
                  striped: true,
                  className: 'fs-10 mb-0 overflow-hidden'
                }}
              />
            </Card.Body>
            <Card.Footer>
              <div className="mt-3">
                <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
              </div>
            </Card.Footer>
          </>
        </Card>
      </AdvanceTableProvider>
      <Modal
        show={showModel}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Email Alert</Modal.Title>
          <FalconCloseButton onClick={handleClose} />
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-2" controlId="content">
            <Form.Label className="fs-9">Content</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="content"
              onChange={handleChange}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={() => sendEmail()}>
            Send Email
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

Customers.propTypes = {
  updateCustomer: PropTypes.any,
  deleteRecord: PropTypes.any,
  customers: PropTypes.any,
  downloadData: PropTypes.any,
  setCustomers: PropTypes.any,
  getCustomer: PropTypes.any,
  setShow: PropTypes.any,
  setData: PropTypes.any
};

export default Customers;
